function normalizeText(value) {
  if (typeof value !== "string") {
    return "";
  }
  return value.trim();
}

export function isOwnerAmbiguous(owner) {
  if (!owner || owner.isAmbiguous !== true) {
    return false;
  }
  return Number.isInteger(owner.candidateCount) && owner.candidateCount > 1;
}

export function alternatePrimaryText(owner) {
  const displayName = normalizeText(owner && owner.displayName);
  if (displayName) {
    return displayName;
  }
  const email = normalizeText(owner && owner.email);
  if (email) {
    return email;
  }
  const ownerRef = normalizeText(owner && owner.ownerRef);
  if (ownerRef) {
    return ownerRef;
  }
  return "-";
}

export function formatAmbiguityAlternateLine(owner) {
  const primary = alternatePrimaryText(owner);
  const email = normalizeText(owner && owner.email) || "-";
  const oid = normalizeText(owner && owner.oid) || "-";
  const unresolved = owner && owner.isUnresolved === true;
  const base = primary + " | " + email + " | " + oid;
  return unresolved ? base + " | unresolved" : base;
}
